import React from 'react'

function About() {
  return (
    <div className='about-container'>
      <div className="about-banner">
        <h1 className='about-title'>About Me</h1>
      </div>
      <div className="about-content">
        <h2>Welcome to Travel Snapshot Journal</h2>
        <p>At Travel Snapshot Journal,we believe in the power of exploration and the joy of capturing unforgettable moments.
            Our mission is to showcase the beauty of popular places in Visakhapatnam--City of Destiny and inspire travelers to embark on new journeys.
        </p>
        <h3>Why Choose us?</h3>
        <ul>
            <li>Comprehensive guides to iconic locations.</li>
            <li>User-friendly interactive map for easy navigation.</li>
            <li>Seamless and inspiring travel experiences.</li>
        </ul>
        <p>
            Whether you're a local adventurer or a global traveler,we aim to make every journey special and memorable.
        </p>
        <h3>Our Vision</h3>
        <p>To be the go-to platform for exploring and documneting travel experiences, starting from Visakhapatnam and beyond.</p>
      </div>
    </div>
  )
}

export default About
